module.exports = __webpack_public_path__ + "img/card1.08ca835a.png";